//AUTH

export const REGISTER_USER = 'REGISTER_USER';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
//users
export const GET_USERS = 'GET_USERS';
export const EDIT_USERS = 'EDIT_USERS';
export const GET_LOCATIONS = 'GET_LOCATIONS'

// RESET_STATE
export const GET_ORDERS = 'GET_ORDERS'
export const LOAD_MORE_ORDERS = 'LOAD_MORE_ORDERS'

export const ADD_TO_ORDERS = 'ADD_TO_ORDERS'
export const EDIT_ORDER = 'EDIT_ORDER'

export const SET_ORDER_PICS = 'SET_ORDER_PICS'
export const ADD_ORDER_PICS = 'ADD_ORDER_PICS'
export const DELETE_ORDER_PICS = 'DELETE_ORDER_PICS'

// CRUD Actions
export const GET_DATA = 'GET_DATA'
export const LOAD_MORE_DATA = 'LOAD_MORE_DATA'
export const SEARCH_DATA = 'SEARCH_DATA'
export const ADD_ITEM = 'ADD_ITEM'
export const OPEN_EDIT = 'OPEN_EDIT'
export const EDIT_ITEM = 'EDIT_ITEM'
export const DELETE_ITEM = 'DELETE_ITEM'
export const GET_OPTIONS = 'GET_OPTIONS'
export const OPEN_PREVIEW = 'OPEN_PREVIEW'
export const RESET_DATA = 'RESET_DATA'
export const LOG_ACTION = 'LOG_ACTION'

//PACKAGE
export const GET_PACKAGE_DATA = 'GET_PACKAGE_DATA'
export const LOAD_MORE_PACKAGE_DATA = 'LOAD_MORE_PACKAGE_DATA'
export const SEARCH_PACKAGE_DATA = 'SEARCH_PACKAGE_DATA'

//PURCHASE
export const GET_PURCHASE_DATA = 'GET_PURCHASE_DATA'
export const LOAD_MORE_PURCHASE_DATA = 'LOAD_MORE_PURCHASE_DATA'
export const SEARCH_PURCHASE_DATA = 'SEARCH_PURCHASE_DATA'

//PURCHASE
export const GET_PRODUCT_DATA = 'GET_PRODUCT_DATA'
export const LOAD_MORE_PRODUCT_DATA = 'LOAD_MORE_PRODUCT_DATA'
export const CHANGE_PRODUCT_INCOMING = 'CHANGE_PRODUCT_INCOMING'

//Analytics
export const GET_ANALYTICS_DATA = 'GET_ANALYTICS_DATA'
export const LOAD_MORE_ANALYTICS_DATA = 'LOAD_MORE_ANALYTICS_DATA'
export const SEARCH_ANALYTICS_DATA = 'SEARCH_ANALYTICS_DATA,'

///CART
export const GET_CART = 'GET_CART'
export const ADD_CART = 'ADD_CART'
export const EDIT_CART = 'EDIT_CART'
export const DELETE_CART = 'DELETE_CART'
export const CLEAR_CART = 'CLEAR_CART'

///Sheeets
export const GET_GSHEET_INVENTORY_DATA = 'GET_GSHEET_INVENTORY_DATA'
export const GET_GSHEET_PRODUCTS_DATA = 'GET_GSHEET_PRODUCTS_DATA'
export const GSHEET_LOADING = 'GSHEET_LOADING'
export const GSHEET_CHANGE_INVENTORY = 'GSHEET_CHANGE_INVENTORY'

// notifs
export const RT_DB_LISTEN_NOTIFICATION = 'RT_DB_LISTEN_NOTIFICATION'
export const RT_DB_SEND_NOTIFICATION = 'RT_DB_SEND_NOTIFICATION'
export const RT_DB_IS_LISTENING = 'RT_DB_IS_LISTENING'


export const GET_FCM_TOKEN = 'GET_FCM_TOKEN'
export const GET_FCM_OTHER_TOKENS = 'GET_FCM_TOKEN'
export const FCM_LISTEN_NOTIFICATION = 'FCM_LISTEN_NOTIFICATION'
export const FCM_NEW_NOTIFICATION = 'FCM_NEW_NOTIFICATION'

//Daily Sales
export const GET_ALL_MENU = 'GET_ALL_MENU'
export const GET_SALES_DATA = 'GET_SALES_DATA'
export const LOAD_MORE_SALES_DATA = 'LOAD_MORE_SALES_DATA'

//Daily Wasted Menu
export const GET_WASTED_MENU_DATA = 'GET_WASTED_MENU_DATA'
export const LOAD_MORE_WASTED_MENU_DATA = 'LOAD_MORE_WASTED_MENU_DATA'

//Daily Wasted 
export const GET_WASTABLE_ITEMS = 'GET_WASTABLE_ITEMS'
export const GET_WASTE_DATA = 'GET_WASTE_DATA'
export const LOAD_MORE_WASTE_DATA = 'LOAD_MORE_WASTE_DATA'


//Pull out
export const GET_PULLOUT_ITEMS = 'GET_PULLOUT_ITEMS'
export const GET_PULLOUT_DATA = 'GET_PULLOUT_DATA'
export const LOAD_MORE_PULLOUT_DATA = 'LOAD_MORE_PULLOUT_DATA'

//Monthly Inventory
export const GET_ALL_IN_BRANCH = 'GET_ALL_IN_BRANCH'
export const GET_MONTHLY_INVENTORY_DATA = 'GET_MONTHLY_INVENTORY_DATA'
export const LOAD_MORE_MONTHLY_INVENTORY_DATA = 'LOAD_MORE_MONTHLY_INVENTORY_DATA'



//Chat 

export const GET_MESSAGES = 'GET_MESSAGES';
export const LOAD_MORE_MESSAGES = 'LOAD_MORE_MESSAGES';
export const SEND_MESSSAGE = 'SEND_MESSSAGE';
export const ADD_MESSSAGE = 'ADD_MESSSAGE';
export const DELETE_MESSAGE = 'SEND_MESSSAGE';
export const CHANGE_CHAT = 'CHANGE_CHAT';
export const ADD_CHAT_SUBSCRIPTION = 'ADD_CHAT_SUBSCRIPTION';




